export default "__VITE_ASSET__Bd54OqZe__"